"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var c = __importStar(require("../constants/remoting"));
var remoting_1 = __importDefault(require("../actions/remoting"));
var safe_access_1 = __importDefault(require("safe-access"));
var js_logger_1 = __importDefault(require("js-logger"));
var config_1 = __importDefault(require("../config"));
var sdp_1 = require("../utils/sdp");
var nucleus_1 = require("@lifesize/nucleus");
var transform = require('sdp-transform');
var rtcIceConnectionState = nucleus_1.nucleusConstants.rtcIceConnectionState;
/** @type {RTCPeerConnection?} */
var peerConnection = null;
var cachedRemoteIceCandidates = [];
var cleanUpPeerConnection = function () {
    if (peerConnection && peerConnection.signalingState !== 'closed') {
        peerConnection.close();
    }
    peerConnection = null;
};
/**
 * acquire the local stream and add it to the peerConnection track
 */
var getLocalStream = function () { return __awaiter(void 0, void 0, void 0, function () {
    var stream, err_1, tracks;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ video: {
                            width: 1024, height: 720
                        }, audio: true })];
            case 1:
                stream = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                js_logger_1.default.error('unable to acquire user media:', err_1);
                return [3 /*break*/, 3];
            case 3:
                tracks = ((_a = stream) === null || _a === void 0 ? void 0 : _a.getTracks()) || [];
                tracks.forEach(function (track) { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.addTrack(track, stream); });
                return [2 /*return*/];
        }
    });
}); };
/**
 * an incoming offer has been received by the presenter
 * and a local stream will be acquired to be sent to the presenter
 * @param {Object} store - Redux store
 */
var handleOffer = function (store, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: 
            // request turn servers
            return [4 /*yield*/, store.dispatch(nucleus_1.callActions.getRelayServersGalaxy())];
            case 1:
                // request turn servers
                _b.sent();
                // create the new peer connection (any open peerConnection will first be cleaned up)
                js_logger_1.default.info('handling new lifesize connect offer');
                createPeerConnection(store);
                // add local stream to peerConnection track
                getLocalStream();
                (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.setRemoteDescription(new window.RTCSessionDescription(payload)).then(function () { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.createAnswer(); }).then(function (answer) {
                    return new Promise(function (resolve, reject) {
                        var _a;
                        if (answer) {
                            js_logger_1.default.info('answer created: ', answer);
                            var sdp = transform.parse(answer.sdp);
                            answer.sdp = sdp_1.limitBandwidth(sdp, nucleus_1.nucleusConstants.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS);
                            (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.setLocalDescription(answer).then(function () {
                                var _a;
                                js_logger_1.default.info('local: ', (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.localDescription);
                                resolve(null);
                            }).catch(function (err) {
                                js_logger_1.default.error('');
                                reject(err);
                            });
                        }
                        else {
                            js_logger_1.default.error('No answer sdp created');
                            reject('No answer sdp created');
                        }
                    });
                }).then(function () { return handleIceCandidate(); }).then(function () {
                    var _a, _b;
                    store.dispatch(remoting_1.default.sendToDisplay.lifesizeConnect.answer((_a = peerConnection) === null || _a === void 0 ? void 0 : _a.localDescription));
                    js_logger_1.default.info('sent sdp answer:', (_b = peerConnection) === null || _b === void 0 ? void 0 : _b.localDescription);
                }).catch(js_logger_1.default.error);
                return [2 /*return*/];
        }
    });
}); };
var handleAnswer = function (store, payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!peerConnection) return [3 /*break*/, 2];
                return [4 /*yield*/, peerConnection.setRemoteDescription(new window.RTCSessionDescription(payload))];
            case 1:
                _a.sent();
                handleIceCandidate();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * stops a wireless presentation on GEMS
 * - the html button on the presenter has been clicked
 * @param {Object} store - Redux store
 */
var handleStopSharing = function (store) {
    // end the presentation on the presenter
    store.dispatch(remoting_1.default.sendToDisplay.lifesizeConnect.end());
    // if the html button was used to stop the presentation, close the extension bar
    var presentationTrack = safe_access_1.default(peerConnection, 'getSenders()[0].track');
    if (presentationTrack)
        presentationTrack.stop();
    // clean up the presenter's peer connection
    cleanUpPeerConnection();
};
/**
 * stops a wireless presentation on the presenter
 * - stops the presentation stream,
 * - cleans up the peer connection,
 * - updates the redux state (which updates the remoting state, which updates presenter)
 * @param {Object} store - Redux store
 */
var stopPresentation = function (store) {
    store.dispatch({ type: c.actions.LIFESIZE_CONNECT_EXCHANGE_PRESENTER, payload: { newConnector: null } });
    store.dispatch({ type: c.actions.LIFESIZE_CONNECT_SEND_END });
};
var createPeerConnection = function (store) {
    var state = store.getState();
    var iceServers = safe_access_1.default(state, 'nucleus.galaxy.capabilities.iceServers') || [];
    cleanUpPeerConnection();
    peerConnection = new window.RTCPeerConnection(__assign({ iceServers: iceServers, peerIdentity: 'lifesize-connect' }, config_1.default.rtcPeerConnectionOptions));
    // now using the ontrack() method (peerConnection.onaddstream() was deprecated)
    peerConnection.ontrack = function (e) {
        return store.dispatch({
            type: c.actions.LIFESIZE_CONNECT_ON_STREAM,
            payload: safe_access_1.default(e, 'streams[0]')
        });
    };
    peerConnection.onicecandidate = function (e) {
        if (e.candidate) {
            store.dispatch(remoting_1.default.sendToDisplay.lifesizeConnect.ice(e.candidate));
        }
    };
    peerConnection.oniceconnectionstatechange = function () {
        var iceConnectionState = safe_access_1.default(peerConnection, 'iceConnectionState');
        js_logger_1.default.info('lifesize connect peer connection ice state changed:', iceConnectionState);
        /* if the peerConnection has been lost, stop the presentation on the display and presenter independently
         * (because it may be due to a connection failure) */
        store.dispatch({ type: c.actions.LIFESIZE_CONNECT_ICE_STATE_CHANGE, payload: iceConnectionState });
        if (iceConnectionState === rtcIceConnectionState.disconnected ||
            iceConnectionState === rtcIceConnectionState.failed) {
            stopPresentation(store);
        }
    };
};
/**
 * handleIceCandidate
 * This function takes a remote ice candidate and appends it to the cached list of remote candidates.
 * If a peer connection is ready to accept remote candidates by detecting if a remotedescription has a type,
 * the function will then process the array of remote candidates by adding them to the peer connection.
 * The function clones and clears the cached array when it process the candidates.
 */
var handleIceCandidate = function (store, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var clonedRemoteIceCandidates, addIceCandidatePromises;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (payload)
                    cachedRemoteIceCandidates = cachedRemoteIceCandidates.concat([payload]);
                if (!safe_access_1.default(peerConnection, 'remoteDescription.type') || !cachedRemoteIceCandidates.length)
                    return [2 /*return*/];
                clonedRemoteIceCandidates = JSON.parse(JSON.stringify(cachedRemoteIceCandidates));
                cachedRemoteIceCandidates = [];
                addIceCandidatePromises = clonedRemoteIceCandidates.map(function (candidate) { var _a; return (_a = peerConnection) === null || _a === void 0 ? void 0 : _a.addIceCandidate(new window.RTCIceCandidate(candidate)); });
                return [4 /*yield*/, Promise.all(addIceCandidatePromises)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var handleCreateOffer = function (store) { return __awaiter(void 0, void 0, void 0, function () {
    var offer, sdp, e_1;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 5, , 6]);
                // request turn servers
                return [4 /*yield*/, store.dispatch(nucleus_1.callActions.getRelayServersGalaxy())];
            case 1:
                // request turn servers
                _e.sent();
                // create the peer connection
                createPeerConnection(store);
                return [4 /*yield*/, ((_a = peerConnection) === null || _a === void 0 ? void 0 : _a.createOffer({ offerToReceiveVideo: true, offerToReceiveAudio: true }))];
            case 2:
                offer = _e.sent();
                if (!offer) return [3 /*break*/, 4];
                sdp = transform.parse(offer.sdp);
                offer.sdp = sdp_1.limitBandwidth(sdp, nucleus_1.nucleusConstants.GALAXY_DEFAULT_CALL_BANDWIDTH_KBPS);
                return [4 /*yield*/, ((_b = peerConnection) === null || _b === void 0 ? void 0 : _b.setLocalDescription(offer))];
            case 3:
                _e.sent();
                _e.label = 4;
            case 4:
                store.dispatch(remoting_1.default.sendToDisplay.lifesizeConnect.offer((_c = peerConnection) === null || _c === void 0 ? void 0 : _c.localDescription));
                js_logger_1.default.info('send sdp offer:', (_d = peerConnection) === null || _d === void 0 ? void 0 : _d.localDescription);
                return [3 /*break*/, 6];
            case 5:
                e_1 = _e.sent();
                js_logger_1.default.error(e_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
var actionMap = (_a = {},
    _a[c.actions.LIFESIZE_CONNECT_ANSWER_RECEIVED] = handleAnswer,
    _a[c.actions.LIFESIZE_CONNECT_CREATE_OFFER] = handleCreateOffer,
    _a[c.actions.LIFESIZE_CONNECT_ICECANDIDATE] = handleIceCandidate,
    _a[c.actions.LIFESIZE_CONNECT_OFFER_RECEIVED] = handleOffer,
    _a[c.actions.LIFESIZE_CONNECT_SEND_END] = handleStopSharing,
    _a[c.actions.LIFESIZE_CONNECT_STOP] = stopPresentation,
    _a[c.actions.LIFESIZE_CONNECT_STREAM_ENDED] = cleanUpPeerConnection,
    _a);
var lifesizeConnectMiddleware = function (store) { return function (next) { return function (action) {
    var result = next(action);
    var handler = actionMap[action.type];
    if (handler) {
        handler(store, action.payload);
    }
    return result;
}; }; };
exports.default = lifesizeConnectMiddleware;
